window.addProductVariantToCart = async (variantId, count, onSuccess, onError) => {
  try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) throw new Error('Cart drawer not found');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', count);
      formData.append(
          'sections',
          cartDrawer.getSectionsToRender()?.map(section => section.section) ?? []
      );
      formData.append('sections_url', window.location.pathname);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(routes.cart_add_url, config);
      const data = await response.json();

      if (!response.ok) throw new Error(data.description);

      cartDrawer.renderContents(data, true);

      // Reload cart page after successful add
      if (window.location.pathname === '/cart') {
          window.location.reload();
      }

      onSuccess?.();
  } catch (error) {
      onError?.(error.message || 'Failed to add to cart');
      console.error('Add to cart failed:', error);
  }
};